export default "__VITE_ASSET__SD5f$f2K__"